var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinsHand32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#D3F8DF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6986_86495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0197 13.5686C16.6381 13.8406 16.1711 14.0007 15.6667 14.0007C14.378 14.0007 13.3334 12.956 13.3334 11.6673C13.3334 10.3787 14.378 9.33398 15.6667 9.33398C16.502 9.33398 17.2348 9.77293 17.647 10.4327M12 21.3921H13.7402C13.9671 21.3921 14.1926 21.4191 14.4126 21.4731L16.2513 21.9199C16.6503 22.0171 17.0659 22.0265 17.469 21.9483L19.502 21.5527C20.0391 21.4481 20.5331 21.1909 20.9203 20.8143L22.3586 19.4151C22.7694 19.0162 22.7694 18.3689 22.3586 17.9694C21.9888 17.6096 21.4032 17.5691 20.9848 17.8742L19.3084 19.0972C19.0684 19.2727 18.7762 19.3672 18.4758 19.3672H16.857L17.8874 19.3672C18.4682 19.3672 18.9386 18.9095 18.9386 18.3446V18.1401C18.9386 17.671 18.6104 17.262 18.1428 17.1486L16.5524 16.7618C16.2936 16.699 16.0286 16.6673 15.7621 16.6673C15.1189 16.6673 13.9546 17.1999 13.9546 17.1999L12 18.0172M21.3334 12.334C21.3334 13.6226 20.2887 14.6673 19 14.6673C17.7114 14.6673 16.6667 13.6226 16.6667 12.334C16.6667 11.0453 17.7114 10.0007 19 10.0007C20.2887 10.0007 21.3334 11.0453 21.3334 12.334ZM9.33337 17.734L9.33337 21.6007C9.33337 21.974 9.33337 22.1607 9.40604 22.3033C9.46995 22.4288 9.57194 22.5307 9.69738 22.5947C9.83999 22.6673 10.0267 22.6673 10.4 22.6673H10.9334C11.3067 22.6673 11.4934 22.6673 11.636 22.5947C11.7615 22.5307 11.8635 22.4288 11.9274 22.3033C12 22.1607 12 21.974 12 21.6007V17.734C12 17.3606 12 17.1739 11.9274 17.0313C11.8635 16.9059 11.7615 16.8039 11.636 16.74C11.4934 16.6673 11.3067 16.6673 10.9334 16.6673L10.4 16.6673C10.0267 16.6673 9.83999 16.6673 9.69738 16.74C9.57194 16.8039 9.46995 16.9059 9.40604 17.0313C9.33337 17.1739 9.33337 17.3606 9.33337 17.734Z",
    stroke: "#16B364",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6986_86495"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinsHand32);
export default __webpack_public_path__ + "static/media/coins-hand-32.301d5fcb7828dca3d1ff379fba28a19e.svg";
export { ForwardRef as ReactComponent };